import React from 'react';
import { TextArea, Form } from 'semantic-ui-react';
import { MessageState } from './helpers/MessageUtility';
import { TrackedMessageState } from './MessagesV2';

export type PromptTextBoxProps = {
  message: MessageState;
  state: TrackedMessageState;
  inputRef: React.Ref<TextArea | HTMLInputElement>;
  onPromptValueChange: (e: React.ChangeEvent, id: number) => void;
  onKeyDown?: (e: React.KeyboardEvent, id: number) => void;
};

export default function PromptTextBox({ message, state, inputRef, onPromptValueChange, onKeyDown }: PromptTextBoxProps) {
  if (message.multiLine) {
    return (
      <Form>
        <TextArea
          value={(state[message.id] ? state[message.id].text : null) || ''}
          onChange={(e) => {
            onPromptValueChange(e, message.id);
          }}
          maxLength={message.maxLength}
          ref={inputRef as React.Ref<TextArea>}
        />
      </Form>
    );
  }

  return (
    <div className="ui input fluid">
      <input
        value={(state[message.id] ? state[message.id].text : null) || ''}
        onChange={(e) => {
          onPromptValueChange(e, message.id);
        }}
        onKeyDown={(e) => {
          onKeyDown?.call(null, e, message.id);
        }}
        maxLength={message.maxLength}
        ref={inputRef as React.Ref<HTMLInputElement>}
      />
    </div>
  );
}
